// extracted by mini-css-extract-plugin
export default {"title":"WeedingPassDetails_title__ivOjB","total":"WeedingPassDetails_total__21XNQ","pay":"WeedingPassDetails_pay__Z0RzE","edit":"WeedingPassDetails_edit__+6pK+"};